import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-pick-action',
  templateUrl: './pick-action.component.html',
  styleUrls: ['./pick-action.component.scss'],
})
export class PickActionComponent implements OnInit {
  config = {
    type: '',
    pageType: 'EXTERNAL',
    value: ''
  };
  constructor(private fb: FormBuilder,
    public modalController: ModalController
    ) { }

  ngOnInit() {
  }
  dismiss(data?) {
    this.modalController.dismiss(data);
  }
  changeLayout() {

  }
  save() {
    let value = '';
    if (this.config.type === 'PAGE') {
      value = this.config.type + ':' + (this.config.pageType || 'EXTERNAL') + ':' + encodeURIComponent(this.config.value);
    } else {
      value = this.config.type + ':' + this.config.value;
    }
    console.log('Value: ', value);
    this.dismiss({
      result: value
    });
  }
}
